import { X } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Tooltip } from './Tooltip';
import { cn } from 'src/utils/className';

interface SkillProps {
  label: string;
  tooltip?: string;
  selected?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
}

export const SkillChip: React.FC<SkillProps> = ({
  label,
  tooltip,
  selected = false,
  onClick,
  onRemove,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <span
      className={cn(
        'inline-flex items-center px-5 py-2 rounded-full font-normal text-base mr-2 transition cursor-pointer',
        selected
          ? 'bg-indigo-100 text-neutral-700 hover:bg-indigo-200 hover:shadow-md'
          : 'bg-neutral-0 border border-neutral-200 hover:border-neutral-300 text-neutral-700',
        isHovered && 'hover:bg-indigo-100',
      )}
      onClick={onClick}
    >
      <Tooltip content={selected ? `Edit skill` : tooltip || `Add skill`}>
        {label}
      </Tooltip>
      {selected && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-2 flex items-center bg-transparent border-none cursor-pointer hover:bg-indigo-200 rounded-md p-1"
          aria-label={`Remove skill`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <X size={16} weight="bold" className="text-neutral-400" />
        </button>
      )}
    </span>
  );
};
